import { Injectable } from '@angular/core';
import { UserActivation } from 'src/app/models/UserActivation';
import { Observable } from 'rxjs';
// var Configuration = require('src/assets/app-config.json');
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { configuration } from 'src/environments/environment';
import { ClientFacility } from 'src/app/models/ClientFacility';
@Injectable({
  providedIn: 'root'
})
export class UserActivationService {
  crypto: any;

  constructor(private http: HttpClient) { }

  // Add user activation details
  addUserActivationInfo(activationDetails: UserActivation): Observable<string> {

    //  var data =  `username=${encodeURIComponent(userName)}&password=${password}:1&grant_type=password`;
    //  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' });
    //  return this.http.post(Configuration.tokenUrl + 'Token',  data.toString(), { headers: reqHeader }).pipe(delay(delayDuration));
    return this.http.post<string>(`${configuration.apiUrl + 'Activation/Activate'}`, activationDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }

  updateUserStatus(activationDetails: UserActivation): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Activation/ActivationStatus'}`, activationDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

  }
  getClientFacilitiies(): Observable<ClientFacility[]> {
    return this.http.get<ClientFacility[]>(
      `${configuration.apiUrl + 'Activation/ClientFacilities'}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }

  getFacilityDetails(clientkey: string, userid: string): any {
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/FacilityDetails'}?clientkey=${clientkey}&&userid=${userid}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }
  getFacilityDetailsById(facilityid: number, userid: string): any {
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/FacilityDetail'}?facilityId=${facilityid}&&userid=${userid}`
      , {
        headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
      });
  }
  CheckAPI(): Observable<boolean> {
    return this.http.get<boolean>(
      `${configuration.apiUrl + 'Activation/CheckAPI'}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }

  getClientIpAddress(): Observable<any> {
    return this.http.get<any>(configuration.ClientIpAdressURL);
  }

  getFacilityByIPAddress(IPDetails): Observable<any> {
    var data = `IPDetails=${IPDetails}`;
    return this.http.get<any>(`${configuration.apiUrl + 'Activation/getFacilityByIPAddress'}?` + data
      , { headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' }) });

  }
  getFacilityByIPAddressByUserId(IPDetails, UserId, clientID): Observable<any> {
    var data = `IPDetails=${IPDetails}&&UserId=${UserId}&&clientID=${clientID}`;
    return this.http.get<any>(`${configuration.apiUrl + 'Activation/getFacilityByIPAddressByUserId'}?` + data
      , { headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' }) });

  }

  ValidateLoginUser(userId, password, ClientIpAddress, MobileNumber, userName, facilityValue): Observable<any> {
    //  var data =  `username=${encodeURIComponent(userName)}&password=${password}:${sessionStorage.getItem("FacilityId")}&grant_type=password`;
    //var data = `userid=${encodeURIComponent(userName)}&&password=${password}&&ClientIpAddress=${ClientIpAddress}&&MobileNumber=${MobileNumber}`;
    var data = {
      userId: userId,
      password: password,
      ipAddress: ClientIpAddress,
      MobileNumber: MobileNumber,
      userName: userName,
      facilityId: facilityValue
    }
    return this.http.post<any>(`${configuration.apiUrl + 'Activation/ValidateLoginUser1'}`, data
      , { headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' }) });
  }

  CheckReceivedOTP(userId: string, otp: string, IPAddress: string): any {
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/ValidateSessionOTP'}?userId=${userId}&&otp=${otp}&&IPAddress=${IPAddress}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }

  CheckOTPTime(userId, activationCode): any {
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/CheckOTPTime'}?activationCode=${activationCode}&&userId=${userId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }
}
